import { lazy } from 'react';

const UserCertification = lazy(() => import('./UserCertification'));;

export default { UserCertification };
